module.exports = __webpack_public_path__ + "static/media/doughnut-2.69be442a.jpeg";